@use '@/scss/underscore' as _;
@use '@/scss/dimensions' as dim;

.container {
  display: flex;
  flex-direction: column;
  background-color: var(--color-base);
  width: 100vw;
  height: 100vh;
  overflow-x: auto;

  > * {
    min-width: dim.$guide-content-min-width;
  }

  .content {
    flex: 1;
    overflow: hidden;
  }
}

@media screen and (max-width: dim.$guide-content-max-width) {
  .container .footerInnerWrapper {
    margin: 0 0 0 _.unit(62.5);
  }
}
